export const COPY_MULTI_ITEM_VALUE_DELIMITER = '\n';
